import { render, staticRenderFns } from "./MultiLevelMenu.component.vue?vue&type=template&id=80c31c3c&"
import script from "./MultiLevelMenu.component.vue?vue&type=script&lang=ts&"
export * from "./MultiLevelMenu.component.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLevelMenu.component.vue?vue&type=style&index=0&id=80c31c3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports